// extracted by mini-css-extract-plugin
export var copyableField = "_pt-4";
export var customerBadge = "_pt-0";
export var customerInfoTitle = "_pt-2";
export var details = "_pt-1";
export var dropdownContainer = "_pt-5";
export var dropdownImage = "_pt-6";
export var editAssigneeForm = "_pt-a";
export var editButton = "_pt-3";
export var email = "_pt-7";
export var hidden = "_pt-d";
export var input = "_pt-8";
export var saveButton = "_pt-b";
export var shopifyIcon = "_pt-c";
export var suggestionBadge = "_pt-e";
export var suggestionText = "_pt-f";
export var username = "_pt-9";